/**
 * Endpoint methods related to Courses Feature
*/

import API from "./Api";

export default {
  /**
   * Gets all the Courses related to the logged-In Instance
   */
  async notify(body) {

    /**
    {
      "to_address" => "recipient@example.com",  // training manager email address
      "template_id" => "27545194",
      "template_parameters" =>   [
          "product_url" => "product_url_Value",
          "product_name" => "product_name_Value",
          "course_name" => "course_name_Value",
          "firstname" => "firstname_Value",
          "lastname" => "lastname_Value",
          "email" => "email_Value",
          "telefon" => "telefon_Value",
          "contact_company_name" => "contact_company_name_Value",
          "contact_company_address" => "contact_company_address_Value",
          "message" => "message_Value",
          "company_name" => "company_name_Value",
          "company_address" => "company_address_Value",
          "course_id" => "",
          "event_id" => "",
        ]
    }

     */

    return API.post("/courseeventinquiry/notify", body,"MOODLE_SESSION_JSON");

  },
};
